import { push } from 'connected-react-router';
import axios from 'axios';
import * as types from './types';
import jwtDecode from 'jwt-decode';

const AUTH_URL = '/api/v1/auth/';
const AUTH_URL_SIGNUP = '/api/v1/signup/';
const AUTH_URL_REFRESH = '/api/v1/auth/refresh/';

const localStorageKeys = {
   accessToken: 'accessToken',
   refreshToken: 'refreshToken'
}

// Устанавливаем токен для всех axios-запросов
const setAuthToken = (token) => {
   if (token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
   } else {
      delete axios.defaults.headers.common['Authorization'];
   }
};

export const setCurrentUser = (user) => (dispatch) => {
   dispatch({
      type: types.USER_LOGIN_SUCCESS,
      payload: user,
   });
};

// Вход пользователя
export const signInUser = ({ username, password }, redirect) => {
   return async (dispatch) => {
      try {
         const { data } = await axios.post(AUTH_URL, { username, password });

         localStorage.setItem('accessToken', data.access);
         localStorage.setItem('refreshToken', data.refresh);

         setAuthToken(data.access);

         dispatch({
            type: types.USER_LOGIN_SUCCESS,
            payload: jwtDecode(data.access),
         });

         if (redirect) dispatch(push(redirect));
         else dispatch(push('/project'));
      } catch (e) {
         dispatch({
            type: types.USER_LOGIN_FAILURE,
            payload: e.response ? e.response.data : e,
         });
         console.log(e.response ? e.response.data : e);
      }
   };
};

export const refreshToken = async () => {
    const refresh = localStorage.getItem(localStorageKeys.refreshToken);

    const { data } = await axios.create().post(AUTH_URL_REFRESH, { refresh });

    localStorage.setItem(localStorageKeys.accessToken, data.access);
    setAuthToken(data.access);

    return data.access;
}

// Выход пользователя
export const signOutUser = () => (dispatch) => {
   localStorage.removeItem('accessToken');
   localStorage.removeItem('refreshToken');
   setAuthToken(null);

   dispatch({ type: types.USER_LOGOUT });
   dispatch(push('/signin'));
};

// Проверка пользователя при загрузке фронта
export const checkUser = () => (dispatch) => {
   const token = localStorage.getItem('accessToken');
   if (token) {
      setAuthToken(token);
      dispatch({
         type: types.USER_LOGIN_SUCCESS,
         payload: jwtDecode(token),
      });
   }
};

// Регистрация пользователя
export const signUpUser = ({ username, password, password2 }, redirect) => {
   return async (dispatch) => {
      try {
         const { data } = await axios.post(AUTH_URL_SIGNUP, { username, password, password2 });

         localStorage.setItem('accessToken', data.access);
         localStorage.setItem('refreshToken', data.refresh);

         setAuthToken(data.access);

         dispatch({
            type: types.USER_LOGIN_SUCCESS,
            payload: jwtDecode(data.access),
         });

         if (redirect) dispatch(push(redirect));
         else dispatch(push('/'));
      } catch (e) {
         dispatch({
            type: types.USER_LOGIN_FAILURE,
            payload: e.response ? e.response.data : e,
         });
         console.log(e.response ? e.response.data : e);
      }
   };
};
